export default "__VITE_ASSET__BlJTZLWI__"